import React, { useEffect, useState } from 'react';
import { onUpdateReady, applyUpdate } from '../serviceWorkerRegistration';

/**
 * "New version ready" notice. It only appears when an update has downloaded
 * and never reloads on its own, so a service in progress is not interrupted.
 */
const UpdateBanner = () => {
  const [registration, setRegistration] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => onUpdateReady(setRegistration), []);

  if (!registration || dismissed) return null;
  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 rounded-lg bg-slate-800 text-slate-50 border border-slate-600 shadow-xl px-4 py-2 text-sm"
    >
      <span>A new version of SleekHear is ready.</span>
      <button
        type="button"
        onClick={() => applyUpdate(registration)}
        className="px-3 py-1 rounded bg-brand-600 hover:bg-brand-500 font-semibold"
      >
        Reload now
      </button>
      <button type="button" onClick={() => setDismissed(true)} className="opacity-70 hover:opacity-100" aria-label="Dismiss">
        Later
      </button>
    </div>
  );
};

export default UpdateBanner;
